import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-hot-toast'

import { identityServices } from '../identityServices'
import { UploadAvatarPayload } from '../identityTypes'
import { QUERY_KEYS } from '@/constants/queryKeys'

interface UseUploadAvatarOptions {
  onSuccess?: (message: string) => void
  onError?: (error: string) => void
}

export const useUploadAvatar = (options?: UseUploadAvatarOptions) => {
  const { t } = useTranslation()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload: UploadAvatarPayload) =>
      identityServices.uploadAvatar(payload),

    onError: (error: any) => {
      const errorMessage =
        error?.response?.data?.message || t('api:errorAvatarUpdating')
      toast.error(errorMessage)

      if (options?.onError) {
        options.onError(errorMessage)
      }
    },

    onSuccess: (data) => {
      // Refresh user cache (same as React Native version)
      queryClient.refetchQueries({ queryKey: [QUERY_KEYS.IDENTITY_ME] })

      const successMessage = data.message || t('form:success.changesSaved')
      toast.success(successMessage)

      if (options?.onSuccess) {
        options.onSuccess(successMessage)
      }
    },
  })
}
